import Intro from "../../components/intro/Intro";
import Clickard from "../../components/Clickard/Clickard";

const VirtualCookbook = () => {
  return (
    <>
      <Intro
        primary="COOKBOOK"
        secondary="An interactive cookbook that walks you through each recipe. Soon, you'll be able to add your own recipes. For now, if you want to cook one of mine..."
        tertiary="You're in the right place."
      />
      <div className="column p01 g1">
        <h2>MY FAVORITES</h2>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/loaf_2x1.jpg",
              alt: "banana bread",
            }}
            link="/cookbook/banana-bread"
            text="Banana Bread"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/pancakes.webp",
              alt: "pancakes",
            }}
            link="/cookbook/pancakes"
            text="Pancakes"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/popcorn.jpg",
              alt: "popcorn",
            }}
            link="/cookbook/popcorn"
            text="Popcorn"
          />
        </div>
      </div>
    </>
  );
};

export default VirtualCookbook;
